export default "__VITE_ASSET__B2QhOJ95__"